<script setup lang="ts">
import { MediaPreview, MediaPreviewBig } from '#components';

const props = defineProps({
    title: {
        type: String,
        default: ''
    },
    type: {
        type: String as PropType<'channel' | 'vod'>,
        default: 'channel'
    },
    lastButtonUrl: {
        type: String,
        default: ''
    }
});

// Type items from query
const queryType = computed(() => {
    if (props.type !== 'channel') {
        return ['container', 'item'];
    } else {
        return ['channel'];
    }
});

// request favorite
const items = ref();
const slots = useSlots();
onMounted(() => {
    useFetchProxyApi(`/api/user/media/favorite`, {
        params: {
            type: queryType.value
        },
        transform: (response: any) => {
            const result = response?.data?.items;
            if (result && result.length && slots.lastButton) {
                result.push({
                    lastButton: true
                });
            }
            return result;
        }
    }).then(({ data }: any) => {
        // Url
        items.value = data.value.map((data: any) => {
            if (!data?.lastButton) {
                data.url = useUrl(data);
            } else {
                data.url = props.lastButtonUrl;
            }
            return data;
        });
    });
});
</script>

<template>
    <div v-if="items && items.length" class="mt-32">
        <h2 class="title fs-30 fs_m-24">{{ props.title }}</h2>
        <div class="mt-24">
            <CarouselBaseHorizontal :items="items" @selected="(e) => navigateTo(e.data.url)">
                <template #default="{ data }">
                    <!-- items  -->
                    <component
                        :is="props.type === 'channel' ? MediaPreview : MediaPreviewBig"
                        v-if="!data?.lastButton"
                        :type="data?.type"
                        :item="data?.item"
                    />
                    <!-- LAST BUTTON -->
                    <slot v-else name="lastButton"></slot>
                </template>
            </CarouselBaseHorizontal>
        </div>
    </div>
</template>
